import React from 'react';
import { siteData } from '../mock';

const Footer = () => {
  return (
    <footer className="relative overflow-hidden border-t border-white/10 bg-black py-10">
      <div className="grain-overlay opacity-20"></div>

      <div className="relative z-10 mx-auto flex max-w-7xl flex-col gap-4 px-4 lg:flex-row lg:items-end lg:justify-between lg:px-8">
        <div>
          <p className="mb-2 text-lg font-semibold tracking-[0.18em] text-white">{siteData.brand}</p>
          <p className="max-w-xl text-sm leading-7 text-white/55">{siteData.intro}</p>
        </div>

        <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-white/35">
          © {new Date().getFullYear()} Biggie Poppins · V3 preview
        </p>
      </div>
    </footer>
  );
};

export default Footer;
